/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { useIntl } from 'react-intl-next';

import { cssMap, cx, jsx } from '@atlaskit/css';
import { Box, Text } from '@atlaskit/primitives/compiled';

import { i18n } from './messages';

const styles = cssMap({
	text: {
		textDecoration: 'none',
	},
});

export const AIDisclaimer = () => {
	const { formatMessage } = useIntl();

	const disclaimerMessage = formatMessage(i18n.disclaimerMessage);

	return (
		<Box xcss={cx(styles.text)}>
			<Text size="small" color="color.text.subtlest">
				{disclaimerMessage}
			</Text>
		</Box>
	);
};
